import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import LogoWordmark from "./LogoWordmark";
import { COMPANY, NAV_LINKS, MAILTO_HREF } from "@/lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-offwhite/80">
      <div className="section-container grid gap-10 py-14 md:grid-cols-3">
        <div>
          <LogoWordmark />
          <p className="mt-4 max-w-xs text-sm text-offwhite/60">
            {COMPANY.tagline}.
          </p>
        </div>

        <div>
          <h3 className="font-display text-sm uppercase tracking-wide text-offwhite">
            Navigate
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="hover:text-offwhite">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm uppercase tracking-wide text-offwhite">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={18} className="mt-0.5 shrink-0 text-brick-light" />
              <span>
                {COMPANY.addressLine1}
                <br />
                {COMPANY.addressLine2}
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={18} className="shrink-0 text-brick-light" />
              <a href={MAILTO_HREF} className="hover:text-offwhite">
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="section-container flex flex-col items-center justify-between gap-2 py-5 text-xs text-offwhite/50 md:flex-row">
          <span>&copy; {year} {COMPANY.name}. All rights reserved.</span>
          <span>{COMPANY.city}, {COMPANY.region}</span>
        </div>
      </div>
    </footer>
  );
}
